import React from "react";
import "./Reinigungsservice.css";
import Reinigungsmittel from "../../asset/Reinigungsmittel.png";

export function ReinigungsService() {
  return (
    <section id="clean" className="green-container pt-4 pb-5">
      <div className="container py-4">
        <h1 className="fs-1 fw-bold font-monospace text-center mb-5">
          Reinigungsservice
        </h1>

        <div className="row align-items-center justify-content-center g-5">
          <div className="col-lg-4 text-center">
            <img
              className="img-fluid cleaning-image"
              src={Reinigungsmittel}
              alt="Reinigungsservice"
            />
          </div>

          <div className="col-lg-6">
            <div className="cleaning-text-box">
              <p className="fs-4 mb-4">
                Wir bieten professionelle Reinigungsdienste für Unternehmen aller
                Art. Unsere Leistungen umfassen:
              </p>

              <ul className="cleaning-list fs-4">
                <li>
                  Büroreinigung: Saubere und gepflegte Arbeitsumgebungen, täglich
                  oder wöchentlich.
                </li>
                <li>
                  Fensterreinigung: Streifenfreie Sauberkeit für Ihre Glasflächen.
                </li>
                <li>
                  Grundreinigung: Gründliche Reinigung für Böden, Teppiche und
                  mehr.
                </li>
                <li>
                  Hygieneservice: Regelmäßige Desinfektion und Reinigung von
                  sanitären Anlagen.
                </li>
                
              </ul>
              <p className="fs-4 mt-3">
  Verlassen Sie sich auf unsere Qualität und Zuverlässigkeit!
</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}